import { SpendTypeEnum } from 'components/Classification';
import { IAllocation, DimensionTypeEnum } from './types';

export const dimensionOptions = {
  [SpendTypeEnum.THIRD_PARTY]: [
    { label: 'Service towers', value: DimensionTypeEnum.ServiceTowers },
    { label: 'Vendors', value: DimensionTypeEnum.Vendors },
  ],
  [SpendTypeEnum.PERSONNEL]: [
    { label: 'Job roles / Individuals', value: DimensionTypeEnum.JobRoles },
    { label: 'Service towers', value: DimensionTypeEnum.ServiceTowers },
  ],
};

export const contributionField = {
  [SpendTypeEnum.THIRD_PARTY]: 'ThirdParty',
  [SpendTypeEnum.PERSONNEL]: 'Personnel',
};

export const contributionQueryParam = {
  [SpendTypeEnum.THIRD_PARTY]: 'Third party',
  [SpendTypeEnum.PERSONNEL]: 'Personnel',
};

export const infoMessage = {
  [SpendTypeEnum.THIRD_PARTY]:
    'Please note you can only allocate one category of third party spend.\n\nThis category will also be used as a drill down in the product analysis, if product data is available.Any changes to application allocation will also impact your product allocation and analysis.',
  [SpendTypeEnum.PERSONNEL]:
    'Please note that you can allocate either a separate job role item or personal spend this item includes',
};

export const getTotalPercentage = (allocations: IAllocation[]) => {
  return allocations.reduce((acc, item) => acc + item.percentage, 0);
};

export const isAllocationItemValid = (items: IAllocation[]) => {
  return getTotalPercentage(items) <= 100;
};

export const dimensionLabels = {
  [DimensionTypeEnum.JobRoles]: 'Job role',
  [DimensionTypeEnum.Vendors]: 'Vendor',
  [DimensionTypeEnum.ServiceTowers]: 'Service Tower',
  [DimensionTypeEnum.Application]: 'Application',
};
